import { createStyles } from '@material-ui/core/styles';

export const TransmitInternalPODialogStyles = createStyles({
    Container: {
        width: 800,
    },
    subTitle: {
        width: 800,
        display: 'inline-block',
        fontSize: 14,
        lineHeight: '20px'
    }
});
